import { useRef, useEffect, useCallback } from "react"

export function useDragScroll() {
  const containerRef = useRef(null)

  const isDragging = useRef(false)
  const startX = useRef(0)
  const scrollLeft = useRef(0)
  const rafId = useRef(null)

  const updateScroll = (dx) => {
    if (!containerRef.current) return
    containerRef.current.scrollLeft = scrollLeft.current - dx
  }

  const requestUpdate = (dx) => {
    if (rafId.current) cancelAnimationFrame(rafId.current)
    rafId.current = requestAnimationFrame(() => {
      updateScroll(dx)
    })
  }

  useEffect(() => {
    const el = containerRef.current
    if (!el) return

    const onMouseDown = (e) => {
      isDragging.current = true
      el.style.scrollBehavior = "auto"

      startX.current = e.clientX
      scrollLeft.current = el.scrollLeft

      el.style.cursor = "grabbing"
      el.style.userSelect = "none"
    }

    const onMouseMove = (e) => {
      if (!isDragging.current) return
      const dx = e.clientX - startX.current
      requestUpdate(dx)
    }

    const onMouseUp = () => {
      isDragging.current = false
      el.style.scrollBehavior = ""

      el.style.cursor = ""
      el.style.userSelect = ""
    }

    el.addEventListener("mousedown", onMouseDown)
    document.addEventListener("mousemove", onMouseMove)
    document.addEventListener("mouseup", onMouseUp)

    return () => {
      el.removeEventListener("mousedown", onMouseDown)
      document.removeEventListener("mousemove", onMouseMove)
      document.removeEventListener("mouseup", onMouseUp)

      if (rafId.current) cancelAnimationFrame(rafId.current)
    }
  }, [])

  // 👉 Touch (mobile)
  const onTouchStart = useCallback((e) => {
    startX.current = e.touches[0].clientX
    scrollLeft.current = containerRef.current?.scrollLeft ?? 0
  }, [])

  const onTouchMove = useCallback((e) => {
    if (!containerRef.current) return

    const dx = e.touches[0].clientX - startX.current

    requestAnimationFrame(() => {
      if (containerRef.current) {
        containerRef.current.scrollLeft = scrollLeft.current - dx
      }
    })

    // ⚠️ tránh scroll dọc bị conflict
    e.preventDefault()
  }, [])

  return {
    ref: containerRef,
    onTouchStart,
    onTouchMove
  }
}
